import React from 'react';
import SignupForm from '../components/Auth/SignupForm';

const SignupPage = () => <SignupForm />;

export default SignupPage;